import React from "react";

const FunFactCard = ({ icon, des }) => {
  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col items-center justify-center gap-2 py-8 px-3 border-r-[1px] border-r-lineColor border-b-[1px] border-b-lineColor">
        <span className="text-2xl text-designColor">{icon}</span>
        <p className="text-base w-full text-center leading-snug text-mutedColor hover:text-textColor duration-200">
          {des}
        </p>
      </div>
    </div>
  );
};

export default FunFactCard;
